import type { Dispatch, SetStateAction } from "react";

import { COMPANY_TEMPLATE_SAMPLE_JOB_TITLE } from "./edit-company-modal.constants";
import type { WrittenQuestionEditorState } from "./edit-company-modal.types";
import { CompetencyModal } from "@/components/screener-builder/review/competency-modal";
import {
  AssessmentQuestionResponseFormat,
  type ReviewPageCompetency,
} from "@/types/screener-builder";
import type { Nullable } from "@/types/utils";

interface WrittenQuestionEditorModalProps {
  editor: Nullable<WrittenQuestionEditorState>;
  onClose: () => void;
  onExitTransitionEnd: () => void;
  setWrittenQuestions: Dispatch<SetStateAction<ReviewPageCompetency[]>>;
  writtenQuestions: ReviewPageCompetency[];
}

// TODO(AS-1925): Company-default AI generation is intentionally disabled for
// this PR. Re-enable company-manage generate/validate wiring and pass
// modal-session job context here when the AI follow-up resumes.
export const WrittenQuestionEditorModal = ({
  editor,
  onClose,
  onExitTransitionEnd,
  setWrittenQuestions,
  writtenQuestions,
}: WrittenQuestionEditorModalProps) => (
  <CompetencyModal
    competency={editor?.competency}
    defaultResponseFormat={AssessmentQuestionResponseFormat.Written}
    isEdit={!!editor?.competency}
    isLegacyScreener={false}
    isPublishedScreener={false}
    jobDescription="Company-level default assessment question template."
    jobTitle={COMPANY_TEMPLATE_SAMPLE_JOB_TITLE}
    onClose={onClose}
    onCompetencyUpdate={setWrittenQuestions}
    onExitTransitionEnd={onExitTransitionEnd}
    opened={editor != null}
    otherCompetencies={writtenQuestions.filter(
      ({ id }) => id !== editor?.competency?.id,
    )}
    readOnly={false}
    saveMode="local"
  />
);
